// Catálogo e ficha de veículos (listagem, filtros, cards, ordenação, ficha, galeria) e valores de catálogo da base — Português (Brasil). Mesmas chaves que es/catalog.ts.
//
// `values`: rótulos em português dos VALORES que a base guarda em espanhol
// (condição, combustível, câmbio, categoria, cor). Só são usados em sites do
// Brasil; o valor em si (filtros, URL, comparações) nunca muda.
export const catalogPt = {
  common: {
    vehicle: 'Veículo',
  },
  listing: {
    loadMore: 'Ver mais veículos',
    viewAll: 'Ver todos os veículos',
    clearSearch: 'Limpar busca',
  },
  search: {
    tip: 'Experimente: "até 80 mil", "sem diesel", "com teto solar"',
    noResultsFor: 'Não encontramos veículos para "{{query}}"',
    didYouMean: 'Você quis dizer?',
    tipsTitle: 'Dicas de busca inteligente',
    tipPrice: '"até 80 mil"',
    tipPriceDesc: ' - Filtra pelo preço máximo',
    tipYear: '"2020 ou mais novo"',
    tipYearDesc: ' - Filtra pelo ano mínimo',
    tipFuel: '"sem diesel"',
    tipFuelDesc: ' - Exclui um tipo de combustível',
    tipFeature: '"com teto solar"',
    tipFeatureDesc: ' - Busca por itens e opcionais',
  },
  filters: {
    expand: 'Expandir filtros',
    collapse: 'Recolher filtros',
    priceRangeAria: 'Faixa de preço',
    yearFrom: 'De',
    yearTo: 'Até',
    anyYear: 'Qualquer',
  },
  promo: {
    limitedTime: 'Tempo limitado',
    countOne: 'carro em promoção',
    countMany: 'carros em promoção',
  },
  card: {
    new: 'Novo',
    recentArrival: 'Recém-chegado',
    opportunity: 'Oportunidade',
    featured: 'Destaque',
    save: 'Economize',
    cashPrice: 'Preço à vista',
    financingPrice: 'Preço financiado',
  },
  detail: {
    viewGallery: 'Ver toda a galeria',
    shareText: 'Olha este {{title}}',
    linkCopied: 'Link copiado!',
    copyError: 'Erro ao copiar',
    whatsappMessage: 'Olá, tenho interesse no {{vehicle}} que vi em {{url}}',
    availableAt: 'Disponível na loja',
    directions: 'Como chegar',
    unsave: 'Remover dos salvos',
  },
  gallery: {
    close: 'Fechar',
    previous: 'Anterior',
    next: 'Próxima',
    exitZoom: 'Sair do zoom',
  },
  values: {
    condition: {
      nuevo: 'Novo',
      semi_nuevo: 'Seminovo',
      seminuevo: 'Seminovo',
      usado: 'Usado',
    },
    fuel: {
      gasolina: 'Gasolina',
      bencina: 'Gasolina',
      diesel: 'Diesel',
      hibrido: 'Híbrido',
      electrico: 'Elétrico',
      flex: 'Flex',
      gnv: 'GNV',
      etanol: 'Etanol',
      gas: 'Gás',
    },
    transmission: {
      manual: 'Manual',
      automatica: 'Automático',
    },
    category: {
      suv: 'SUV',
      sedan: 'Sedã',
      camioneta: 'Caminhonete',
      deportivo: 'Esportivo',
      clasico: 'Clássico',
      coupe: 'Cupê',
      furgon: 'Furgão',
      camion_rigido: 'Caminhão Toco',
      tractocamion: 'Cavalo Mecânico',
      camion_tolva: 'Caminhão Basculante',
      camion_pluma: 'Caminhão Munck',
      camion_cisterna: 'Caminhão Tanque',
      camion_frigorifico: 'Caminhão Frigorífico',
      camion_plataforma: 'Caminhão Plataforma',
      camion_portacontenedores: 'Caminhão Porta-contêiner',
      bus: 'Ônibus',
      minibus: 'Micro-ônibus',
      excavadora: 'Escavadeira',
      retroexcavadora: 'Retroescavadeira',
      cargador_frontal: 'Pá Carregadeira',
      bulldozer: 'Trator de Esteira',
      hatchback: 'Hatch',
      motoniveladora: 'Motoniveladora',
      rodillo_compactador: 'Rolo Compactador',
      minicargador: 'Minicarregadeira',
      mini_excavadora: 'Miniescavadeira',
      grua: 'Guindaste',
      manipulador_telescopico: 'Manipulador Telescópico',
      tractor_agricola: 'Trator Agrícola',
      cosechadora: 'Colheitadeira',
      camion_articulado: 'Caminhão Articulado',
      generador: 'Gerador',
      pickup: 'Picape',
      compresor: 'Compressor',
      montacargas: 'Empilhadeira',
      plataforma_elevadora: 'Plataforma Elevatória',
      lancha: 'Lancha',
      moto_de_agua: 'Moto Aquática',
      velero: 'Veleiro',
      yate: 'Iate',
      bote_inflable: 'Bote Inflável',
      semirrigido: 'Semirrígido',
      ponton: 'Pontão',
      van: 'Van',
      crucero: 'Cruzeiro',
      catamaran: 'Catamarã',
      kayak: 'Caiaque',
      motor_fuera_de_borda: 'Motor de Popa',
      lancha_de_pesca: 'Lancha de Pesca',
      city_car: 'Compacto',
      minivan: 'Minivan',
      station_wagon: 'Perua',
      crossover: 'Crossover',
      moto: 'Moto',
      automovil: 'Automóvel',
      camion: 'Caminhão',
      micro_bus: 'Micro-ônibus',
      cabezal: 'Cavalo Mecânico',
      limusina: 'Limusine',
      buggy: 'Buggy',
      motorhome: 'Motorhome',
      ambulancia: 'Ambulância',
      cuatriciclo: 'Quadriciclo',
      triciclo: 'Triciclo',
      wagon: 'Perua',
      kart: 'Kart',
      bote: 'Barco',
      jet_ski: 'Jet Ski',
      maquinaria: 'Máquinas',
      otro: 'Outro',
      vehiculos_de_trabajo: 'Veículos de trabalho',
      moto_atv_y_utv: 'Moto, ATV e UTV',
      convertible: 'Conversível',
    },
    color: {
      amarillo: 'Amarelo',
      azul: 'Azul',
      azul_oscuro: 'Azul Escuro',
      beige: 'Bege',
      blanco: 'Branco',
      borgona: 'Bordô',
      burdeo: 'Bordô',
      cafe: 'Marrom',
      celeste: 'Azul-claro',
      cobre: 'Cobre',
      dorado: 'Dourado',
      gris: 'Cinza',
      gris_claro: 'Cinza claro',
      gris_oscuro: 'Cinza escuro',
      gris_plata: 'Cinza Prata',
      morado: 'Roxo',
      naranja: 'Laranja',
      naranjo: 'Laranja',
      negro: 'Preto',
      plata: 'Prata',
      plateado: 'Prata',
      rojo: 'Vermelho',
      rosado: 'Rosa',
      terracota: 'Terracota',
      turquesa: 'Turquesa',
      verde: 'Verde',
      verde_claro: 'Verde claro',
      verde_oscuro: 'Verde escuro',
      violeta: 'Violeta',
    },
  },
};
